import { render, staticRenderFns } from "./BackofficeLeftNavBar.vue?vue&type=template&id=0ca13a92"
import script from "./BackofficeLeftNavBar.vue?vue&type=script&lang=ts"
export * from "./BackofficeLeftNavBar.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeLeftNavBar.vue?vue&type=style&index=0&id=0ca13a92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports